import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function PolitiqueConfidentialite() {
  return (
    <div className="font-sans">
      <Navbar />
      <main className="pt-36 pb-24 bg-white">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <h1 className="font-heading font-bold text-navy-900 text-4xl mb-2">Politique de confidentialité</h1>
          <p className="text-gray-400 text-sm mb-10">Dernière mise à jour : avril 2026</p>
          <div className="space-y-8 text-gray-600 leading-relaxed">
            <section>
              <h2 className="font-heading font-semibold text-navy-900 text-xl mb-3">1. Responsable du traitement</h2>
              <div className="bg-gray-50 border-l-4 border-navy-900 pl-5 py-4 pr-4 rounded-r-lg">
                <p><strong className="text-navy-900">CICHORZ</strong> – Mariusz Slawomir Cichorz</p>
                <p>57 Rue Lecourbe, 75015 Paris, France</p>
                <p>Email : mariuszc1chorzz@outlook.com</p>
              </div>
            </section>
            <section>
              <h2 className="font-heading font-semibold text-navy-900 text-xl mb-3">2. Données collectées</h2>
              <p>Le site peut collecter les données suivantes via le formulaire de contact :</p>
              <ul className="list-disc list-inside mt-3 space-y-1 text-sm">
                <li>Nom et prénom</li>
                <li>Adresse email</li>
                <li>Numéro de téléphone</li>
                <li>Description du projet (message)</li>
              </ul>
            </section>
            <section>
              <h2 className="font-heading font-semibold text-navy-900 text-xl mb-3">3. Finalité du traitement</h2>
              <p>Ces données sont collectées et utilisées <strong className="text-navy-900">uniquement</strong> pour répondre aux demandes de contact et de projet soumises via le formulaire. Elles ne sont utilisées à aucune autre fin commerciale ou marketing.</p>
            </section>
            <section>
              <h2 className="font-heading font-semibold text-navy-900 text-xl mb-3">4. Partage des données</h2>
              <p>Les données personnelles collectées ne sont <strong className="text-navy-900">ni vendues, ni partagées</strong> avec des tiers. Elles restent strictement confidentielles et sont traitées uniquement par CICHORZ.</p>
            </section>
            <section>
              <h2 className="font-heading font-semibold text-navy-900 text-xl mb-3">5. Vos droits</h2>
              <p>Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour exercer ces droits, contactez-nous à :</p>
              <p className="mt-2 font-medium text-navy-900">mariuszc1chorzz@outlook.com</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
